import React from "react";
import { ShieldCheck, Bell, Pill, Truck, Sparkles } from "lucide-react";
import StaticPage from "../../components/StaticPage";

const FEATURES = [
    { icon: Pill, title: "Reorder in 2 taps", body: "Your past orders are remembered and one tap refills your chronic-med shelf." },
    { icon: Bell, title: "Refill reminders", body: "AI predicts when you'll run out and pings you 5 days before so you never skip a dose." },
    { icon: Truck, title: "Same-day in 4 cities", body: "Chennai, Bengaluru, Mumbai, Delhi — orders before 1 PM dispatched same day." },
    { icon: ShieldCheck, title: "2FA + biometric lock", body: "Your medical history is yours. Bank-grade encryption + on-device biometric lock." },
    { icon: Sparkles, title: "AI symptom triage", body: "Describe what you feel; we suggest products, doctor consults or urgent care." },
];

const MobileApp = () => (
    <StaticPage
        title="Download PILLS"
        crumb="Mobile App"
        testId="page-mobile-app"
        intro="Manage your health with ease — install PILLS on iOS and Android. Order medicines, track refills, talk to doctors and book lab tests, all from one app."
    >
        <div className="mb-10 grid gap-4 md:grid-cols-3">
            <a href="#" data-testid="mobile-cta-play" className="inline-flex h-14 items-center gap-3 rounded-xl bg-zinc-900 px-5 text-white shadow-md transition-transform hover:scale-[1.02] dark:bg-white dark:text-zinc-900">
                <span className="text-2xl">▶</span>
                <span className="flex flex-col leading-tight">
                    <span className="text-[10px] uppercase tracking-wider opacity-70">Get it on</span>
                    <span className="text-base font-semibold">Google Play</span>
                </span>
            </a>
            <a href="#" data-testid="mobile-cta-appstore" className="inline-flex h-14 items-center gap-3 rounded-xl bg-zinc-900 px-5 text-white shadow-md transition-transform hover:scale-[1.02] dark:bg-white dark:text-zinc-900">
                <span className="text-2xl"></span>
                <span className="flex flex-col leading-tight">
                    <span className="text-[10px] uppercase tracking-wider opacity-70">Download on the</span>
                    <span className="text-base font-semibold">App Store</span>
                </span>
            </a>
            <div className="rounded-xl border border-zinc-200 bg-white p-4 text-xs leading-relaxed text-zinc-500 dark:border-white/10 dark:bg-white/5">
                Production iOS/Android builds are rolling out in stages. Beta access is available on request — email <a href="mailto:beta@pills.asia" className="text-sky-600 hover:underline">beta@pills.asia</a>.
            </div>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {FEATURES.map(({ icon: Icon, title, body }) => (
                <div key={title} className="rounded-2xl border border-zinc-100 bg-white p-5 dark:border-white/10 dark:bg-white/5">
                    <div className="grid h-10 w-10 place-items-center rounded-xl bg-brand-100 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300">
                        <Icon className="h-5 w-5" />
                    </div>
                    <h3 className="mt-3 text-sm font-semibold text-zinc-900 dark:text-zinc-100">{title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-zinc-500 dark:text-zinc-400">{body}</p>
                </div>
            ))}
        </div>
    </StaticPage>
);

export default MobileApp;
